import * as React from "react";
import styled from "styled-components";

import { BREAK_POINTS } from "@origin-digital/style-guide/dist/lib/consts/mediaQuery.const";
import { Metrics, Palette } from "../../vars";

const HeaderbarBottom: React.SFC<any> = ({ children, className }) => (
  <div className={className}>{children}</div>
);

export default styled(HeaderbarBottom)`
  padding-left: ${Metrics.Padding.NAVBAR_LEFT_MD}px;
  border-bottom: 1px solid ${Palette.Rebrand.Colours.G3};

  @media (min-width: ${BREAK_POINTS.Min.XL}) {
    padding-left: ${Metrics.Padding.NAVBAR_LEFT_LG}px;
  }
`;
